var _excluded = ["value", "maximum"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import repeatComponent from "../../../utils/repeatComponent";
import space from "../../../utils/space";
import throwError from "../../../utils/throwError";
import unit from "../../../utils/unit";
var Container = styled.ul.withConfig({
  componentId: "sc-1qyl0uz-0"
})(function (_ref) {
  var $maximum = _ref.$maximum;
  return css(["display:grid;grid-gap:", ";grid-template-columns:repeat(", ",1fr);"], space(0.5), $maximum);
});
var Item = styled.li.withConfig({
  componentId: "sc-1qyl0uz-1"
})(function (_ref2) {
  var $isActive = _ref2.$isActive,
    $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["height:", ";border-radius:", ";", ""], space(1), getBorderRadius(theme, "small"), $isActive ? css(["background:", ";"], getColor(theme, "success")) : css(["border:", " solid ", ";"], unit(1), getBorderColor(theme, $onColor, "low")));
});
function IndicatorMol(_ref3) {
  var value = _ref3.value,
    maximum = _ref3.maximum,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  if (value > maximum) {
    throwError('"value" has to be smaller or equal to "maximum"');
  }
  return /*#__PURE__*/React.createElement(Container, _extends({
    $maximum: maximum
  }, restProps), repeatComponent(maximum, /*#__PURE__*/React.createElement(Item, {
    $onColor: onColor
  }), function (index) {
    return {
      $isActive: index < value
    };
  }));
}
export default IndicatorMol;